import * as React from "react"
import { DayPicker } from "react-day-picker"
import { cn } from "../../lib/utils"

export type CalendarProps = React.ComponentProps<typeof DayPicker>

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}: CalendarProps) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      mode="single"
      timeZone="UTC"
      weekStartsOn={1}
      className={cn("p-3 border border-brand-border shadow-lg rounded-xl", className)}
      classNames={{
        months: 'relative flex flex-wrap justify-center gap-8',
        month_caption:
          'flex items-center font-medium text-lg h-9 px-2 text-brand-white dark:text-brand-white',
        nav: 'absolute inset-x-0 flex justify-end items-center h-9 gap-2',
        button_next:
          'relative inline-flex items-center justify-center size-9 hover:bg-brand-dark dark:hover:bg-brand-dark rounded',
        button_previous:
          'relative inline-flex items-center justify-center size-9 hover:bg-brand-dark dark:hover:bg-brand-dark rounded',
        chevron: 'inline-block size-7 fill-zinc-400 dark:fill-zinc-600',
        week: 'grid grid-cols-7',
        weekdays: 'grid grid-cols-7',
        weekday: 'flex items-center justify-center text-brand-white dark:text-brand-white',
        day: 'rounded-lg w-9 h-9 p-0',
        day_button: 'rounded-md w-9 h-9 flex items-center justify-center text-brand-white dark:text-brand-white hover:bg-brand-dark dark:hover:bg-brand-dark hover:text-brand-dark dark:hover:text-foreground font-normal aria-selected:opacity-100 cursor-pointer',
        today: 'bg-brand-dark dark:bg-brand-dark font-semibold',
        selected:
          'bg-brand-dark dark:bg-brand-gold text-brand-white hover:bg-brand-dark dark:hover:bg-brand-gold hover:text-brand-white focus:bg-brand-dark dark:focus:bg-brand-gold focus:text-brand-white',
        outside: 'text-muted-foreground dark:text-muted-foreground opacity-50',
        disabled: 'text-muted-foreground dark:text-muted-foreground opacity-50 cursor-auto',
        range_middle:
          'aria-selected:bg-brand-light dark:aria-selected:bg-brand-light aria-selected:text-brand-white dark:aria-selected:text-brand-white aria-selected:hover:bg-brand-light dark:aria-selected:hover:bg-brand-light rounded-none',
        hidden: 'invisible',
      }}
      {...props}
    />
  )
}
Calendar.displayName = "Calendar"

export { Calendar }
